import React from 'react'
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormButton from '../../../../library/form/components/FormActionButton2';

const COLUMN_MAP = {
    ViewMenu: 'menu',
    CreateRecord: 'create',
    ViewRecord: 'view',
    EditRecord: 'edit',
    DeleteRecord: 'delete',
    CancelRecord: 'cancel'
};

const formatPrivilegeValue = (columnKey, value) => {
    if (!value || value === 'none' || value === 'no') {
        return '\u2014';
    }

    const normalizedValue = String(value).toLowerCase();

    if ((columnKey === 'menu' || columnKey === 'create') && normalizedValue === 'yes') {
        return '\u2713';
    }
    if (normalizedValue === 'yes') {
        return 'Yes';
    }
    if (normalizedValue === 'own') {
        return 'Own';
    }
    if (normalizedValue === 'group') {
        return 'Group';
    }
    if (normalizedValue === 'all') {
        return 'All';
    }

    return value;
};

const formatAdvancedLabel = (label = '') => {
    //return as it is because short name will be provided from backend for advance privileges
    return label;
    // const withoutCan = label.replace(/^Can\s+/i, '');
    // return withoutCan.replace(/^Manage\s+/i, '').trim();
}

const RolePrivilegeRow = (props) => {
    const { formObject, rowKey, viewData } = props;

    const privilegeMatrix = {
        menu: '\u2014',
        create: '\u2014',
        view: '\u2014',
        edit: '\u2014',
        delete: '\u2014',
        cancel: '\u2014'
    };

    const advancedPrivileges = [];

    Object.values(viewData.rowValues || {})
        .sort((a, b) => a.sortKey - b.sortKey)
        .forEach((rowValue) => {
            if (!rowValue || rowValue.key === 'docType') {
                return;
            }

            const privilegeKey = rowValue.dataList && rowValue.dataList.privilegeKey;
            const columnKey = COLUMN_MAP[privilegeKey];
            if (columnKey) {
                privilegeMatrix[columnKey] = formatPrivilegeValue(columnKey, rowValue.val);
                return;
            }

            if (rowValue.valF) {
                advancedPrivileges.push(formatAdvancedLabel(rowValue.valF));
            }
        });

    const advancedValue = advancedPrivileges.length > 0 ? advancedPrivileges.join(', ') : '\u2014';

    return (
        // <DocRowContainer formObject={formObject} rowKey={rowKey} containerClass="uiSpacerR2" >
        <tr className='uiGridRowType_3'>
            <td className='uiColumnLeft uiColumn200'>
                <FormROValue formObject={formObject} 
                    rowKey={rowKey} action={{ paramName: "docType" }}
                    className="uiBold"
                />
            </td>
            <td className='uiCenter uiColumn70 uiFontSize15'>{privilegeMatrix.menu}</td>
            <td className='uiCenter uiColumn70 uiFontSize15'>{privilegeMatrix.create}</td>
            <td className='uiCenter uiColumn70'>{privilegeMatrix.view}</td>
            <td className='uiCenter uiColumn70'>{privilegeMatrix.edit}</td>
            <td className='uiCenter uiColumn70'>{privilegeMatrix.delete}</td>
            <td className='uiCenter uiColumn70'>{privilegeMatrix.cancel}</td>
            <td className='uiCenter uiColumn150'>{advancedValue}</td>
            <td className='uiCenter uiColumn70'>
                <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="edit"
                    onlyIcon={true}
                    tooltip="Edit"
                    starIconClassName="uiColorNeutralAction"
                    action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                    className="" ></FormButton>

                <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="clear"
                    onlyIcon={true}
                    tooltip="Delete"
                    starIconClassName="uiColorNegativeAction"
                    action={{ actionId: "del",  actionParam: {}, containerKey: "row" }}
                    className="" ></FormButton>
            </td>
        </tr>
        // </DocRowContainer>
    )
}

export default RolePrivilegeRow